
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SanParsedInitData } from "../../../server/data/SanParsedInitData";
import { RevealerManager } from "../../independent/revealer/RevealerManager";
import { JumpingWildController } from "../../independent/jumpingWild/JumpingWildController";
import { SanBackground } from "../../background/SanBackground";
import { PostCounter } from "../../independent/poster/PostCounter";
import { JumpingWildCollector } from "../../independent/collector/JumpingWildCollector";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SanEngineController } from "../../../engine/SanEngineController";

import { SanJumpData } from "../../../server/data/ISanServerData";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { SplashController } from "../../independent/splashScreen/SplashController";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { SoundConfig } from "../../../SoundConfig";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { PosterManager } from "../../independent/poster/PosterManager";
import { AnimationEffects } from "../../../effects/AnimationEffects";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { Power3 } from "gsap";
import { ReelOverlay } from "../../background/ReelOverlay";

class restoreState extends StateHandler{
    public static readonly BONUS_INTRO_START:string = "bonus_intro_start";
    public static readonly BONUS_INTRO_MID:string = "bonus_intro_mid";
    public static readonly BONUS_INTRO_END:string = "bonus_intro_end";

    public static readonly FIRST_FS:string = "first_fs";
    public static readonly NORMAL_FS:string = "normal_fs";

}

export class RestorePresentation extends Presentation {

    private bottomToOpen:boolean[];

    private jumpData:SanJumpData[];

    private restoreState:restoreState = new restoreState(restoreState.NORMAL_FS);

    private _initData:SanParsedInitData

    public setParsedInitData(data:SanParsedInitData){
        this._initData = data;
        
        this.bottomToOpen = data.bottomRowOpen;
        this.PresentationState.set(PresentationState.ACTIVATED);

        if(data.mode == GameMode.NORMAL){
            this.restoreState.set(restoreState.BONUS_INTRO_START)
        }else if(data.mode == "FREESPIN_SETUP"){
            this.restoreState.set(restoreState.FIRST_FS)
        }

        this.jumpData = data.sanJumpData;
    }

    preStart():void{
        // IdleWinPresentation.boomGame();

        PostCounter.instance.setAmount(this._initData.freespinsLeft);
        if(this.restoreState.equal(restoreState.BONUS_INTRO_START)){
            SanEngineManager.isFirstFS = true;
            let count:number = -JumpingWildController.instance.items.length;
            this._initData!.scatterReelPositions.forEach(val => { 
                if(val >= 0 && val <= 2) count++;
            });

            SplashController.instance.setintroVal(count - 2);
            JumpingWildCollector.instance.restoreReActive(count-2);
            JumpingWildCollector.instance.indicatorState(count);
            
            RevealerManager.getAllBars().forEach(r => r.setSpinMode(false));

        }else if(this.restoreState.equal(restoreState.FIRST_FS)){
            let count:number = -JumpingWildController.instance.items.length;
            this.bottomToOpen.forEach(val => { 
                if(val) count++;
            });

            SplashController.instance.setintroVal(count - 2);
            JumpingWildCollector.instance.restoreReActive(count - 2);
            JumpingWildCollector.instance.indicatorState(count);
            RevealerManager.getAllBars().forEach(r => r.setSpinMode(false));

            if(this._initData.fsSym.sym == "W"){
                for(let i:number = 0; i < count-2; i++)
                    JumpingWildCollector.instance.upgradeJWRestore(this._initData.fsSym.val,i);
            }

        }
        else{
            JumpingWildCollector.instance.restoreReActive(this.jumpData.length);
            JumpingWildCollector.instance.indicatorState(this.jumpData.length + 2);

            this.jumpData.forEach((j,i) => {
                if(j.to.multiplier! > 1)
                    JumpingWildCollector.instance.upgradeJWRestore(j.to.multiplier!,i);
            });
        }
    }

    public getPresentation(){

        switch(this.restoreState.state){
            case restoreState.BONUS_INTRO_START:
                this.buttonScreen()
                break;

            case restoreState.BONUS_INTRO_MID:
                this.showBonuHits();
                break;

            case restoreState.BONUS_INTRO_END:
                this.changeBG();

                break;
            case restoreState.FIRST_FS:
                this.bonusFirstFSReset();

                break;
            default:
                this.normalFSReset();
        }
    }

    private normalFSReset():void{
        SanEngineManager.RAll((Reel:number) => SanEngineManager.getReel(Reel).createStart());
        SanEngineManager.RAll((Reel:number) => { SanEngineManager.getReel(Reel).startReel(); })
        SoundManager.playSoundEffect(SoundConfig.instance.REELS_SPINNING,Number.MAX_SAFE_INTEGER);

        SanEngineManager.isPlaying = true;

        SanEngineManager.setQuickStop(false);

        SoundManager.StartFSMusic();
        for(let p:number = 0; p < this.bottomToOpen.length; p++){
            if(this.bottomToOpen[p]){
                this.pTimeline.add(RevealerManager.getTopBar(p).openBar(false),p*0.1);
                this.pTimeline.add(RevealerManager.getBotBar(p).openBar(false),p*0.1);
            }else
            {
                RevealerManager.getBotBar(p).setSpinMode(false);
                RevealerManager.getTopBar(p).setSpinMode(false);
                SanEngineManager.getReel(p).setAttentionSym("S");
            }
        }

        for(let p:number = 0; p < this.bottomToOpen.length; p++){
            RevealerManager.getTopBar(p).shuffle(true);
            RevealerManager.getBotBar(p).shuffle(true);
        }

        this.pTimeline.add(SanBackground.instance.moveBG(true));
        this.pTimeline.add(() => SanBackground.instance.playCherring(),"-=" + 1.2);
        this.pTimeline.add(() => SanBackground.instance.playAtmosphere(JumpingWildController.instance.items.length-1),"-=" + 1.2)
        // this.pTimeline.add(() => SanBackground.instance.fsSpineBG(JumpingWildController.instance.items.length-1),"-=" + 1.2)
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    private bonusFirstFSReset():void {
        // const postDurr:number = this.pTimeline.add(PostCounter.instance.play()).duration();


        // const symKey:string = Object.keys(this._gameData.rawData.specialSymbol)[0];
        // // SplashViewJWWon.changeValue(this._gameData.fsSym.val);

        // SanEngineManager.RAll((r:number) => {
        //     if(SanEngineManager.getReel(r).isActive){
        //         const rc:SanEngineController = SanEngineManager.getReel(r);

        //         rc.AllWindowSymbols.forEach(s => {
        //             if(s.symName === "Z"){
        //                 this.pTimeline.add((<SanSpriteSymbol>s).mysteryExplosion(),0);
        //                 s.changeState({
        //                     state: ReelSymbolStates.CHANGE_SYMBOL,
        //                     forceState: true,
        //                     newSym: symKey,
        //                     type: "4",
        //                     duration: 0.5,
        //                 });
        //             }
        //         })
        //     }
        // });

        this.restoreState.set(restoreState.NORMAL_FS);
    }

    private showBonuHits():void{
        let delay:number = 0.4;
        const nextAnim:number = 0.05;

        let openDelay:number = 0.75;
        if(this.bottomToOpen.indexOf(false) >= 0)
            this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_JAIL_DOOR_CLOSE),openDelay) 
        for(let reel:number = 0; reel < SanEngineManager.AllReels.length;reel++){
            const rc:SanEngineController = SanEngineManager.getReel(reel);
            if(this._initData!.scatterReelPositions[reel] >= 0){
                this.pTimeline.add([
                    () => rc.getSymbol(this._initData!.scatterReelPositions[reel])!.changeState({ state: ReelSymbolStates.IDLE, type:0 }),
                ],delay)
            }else{
                this.pTimeline.add(rc.reelLocker(true), openDelay);
                rc.isActive = false;
            }
            for(let row:number = 0; row < rc.AllWindowSymbols.length;row++){
                const symPos:number = rc.AllWindowSymbols[row].posID;
                this.pTimeline.add(() => rc.getSymbol(symPos)!.attentionDarkness(1,0),delay);
                this.pTimeline.add(() => rc.getSymbol(symPos)!.attentionDarkness(0,0.5),delay+nextAnim);
            }
            this.pTimeline.add(() => rc.AllSymbols.forEach((s) => { if(!s.isScatter){
                s.changeState({state:ReelSymbolStates.NORMAL,duration:0,newSym:"X",forceState:true});
            }}),delay);
            delay += nextAnim;
        }
        
        this.pTimeline.to(this,0.5,{});
        
        SanEngineManager.RAll((Reel:number) => SanEngineManager.getReel(Reel).createStart());
        this.restoreState.set(restoreState.BONUS_INTRO_END);
    }

    private buttonScreen():void{
        this.pTimeline.add([
            PosterManager.instance.setBlackScreenAlpha(0.7,0.4),
            SplashController.instance.play(0),
            ReelOverlay.instance.changeAlpha(0, 0.4),
            SanBackground.instance.changeBgBlackness(0,0.4)
        ]);

        for(let p:number = 0; p < this.bottomToOpen.length; p++){
            if(this.bottomToOpen[p]){
                RevealerManager.getTopBar(p).openBar(true);
                RevealerManager.getBotBar(p).openBar(true);
                
                SanEngineManager.getReel(p).AllWindowSymbols.forEach(s => {if(s.isScatter) s.changeState({ state: ReelSymbolStates.ATTENTION }); } )
            }
            else
                SanEngineManager.getReel(p).setAttentionSym("S");
        }
        
    }

    private changeBG():void{
        
        SanEngineManager.RAll((Reel:number) => { SanEngineManager.getReel(Reel).startReel(); })
        SoundManager.playSoundEffect(SoundConfig.instance.REELS_SPINNING,Number.MAX_SAFE_INTEGER);
        SanEngineManager.isPlaying = true;
        
        RevealerManager.getAllBars().forEach(r => {
            r.killGlow();
            r.setSpinMode(false);
            r.showRevSpinner(false);
        });
        RevealerManager.getAllBars().forEach(b => b.attentionDarkness(0.8, 1.5,true));

        for(let p:number = 0; p < this.bottomToOpen.length; p++){
            RevealerManager.getTopBar(p).shuffle(true);
            RevealerManager.getBotBar(p).shuffle(true);
        }

        const delay:number = 0.25;

        this.pTimeline.add(SanBackground.instance.moveBG(true),delay)
        
        this.pTimeline.add(SanBackground.instance.restoreOverlay(1),delay)
        this.pTimeline.add(() => SanBackground.instance.playCherring(),"-="+2);
        this.pTimeline.add(SplashController.instance.play(2),"-="+1);
        this.pTimeline.add(() => SanBackground.instance.playAtmosphere(JumpingWildController.instance.items.length-1),"-=" + 1)
        // this.pTimeline.add(() => SanBackground.instance.fsSpineBG(JumpingWildController.instance.items.length-1),"-="+1)

        this.pTimeline.add(
            AnimationEffects.Shake({
                obj:StageManager.stage,
                duration:this.pTimeline.duration()*0.75,
                hertz:120,
                x:0.6,
                y:0.8,
                Intensity:4,
                positionCb: () => new PIXI.Point(0,0),
                ease: Power3.easeOut,
                reverseEase:true
        }),delay);
        this.PresentationState.set(PresentationState.INACTIVE)
    }

    public skipPresentation():void{
        if(this.restoreState.equal(restoreState.BONUS_INTRO_START)){

            SoundManager.StartFSMusic();
            SplashController.instance.stop();
            PosterManager.instance.setBlackScreenAlpha(0);

            this.restoreState.set(restoreState.BONUS_INTRO_MID);
            this.pTimeline.totalProgress(1);
        } 
    }

    public stopPresentation():void{
    }
}